'use client';

import { useEffect, useRef } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

import { pathWithQueryString } from '@publishing/helpers/pathWithQuery';

interface EventEndedNoticeProps {
  fallback?: string;
}

export function EventEndedNotice({ fallback = '/event' }: EventEndedNoticeProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const shown = useRef(false);

  useEffect(() => {
    if (shown.current) return;
    shown.current = true;

    alert('종료된 이벤트입니다.');
    router.replace(pathWithQueryString(fallback, searchParams));
  }, [router, fallback, searchParams]);

  return null;
}
